var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',[_c('v-progress-circular',{staticClass:"mb-5",attrs:{"indeterminate":"","color":"amber"}}),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('h1',[_vm._v(_vm._s(_vm.randomText))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }